export type SceneObjectDimensions = {
  width: number;
  height: number;
};

const BASE_OBJECT_SIZE_DESKTOP = 64;
const BASE_OBJECT_SIZE_MOBILE = 50;

// Ajuste fino por objectId para compensar diferenças visuais entre imagens.
// 1.0 = tamanho base; >1 maior; <1 menor.
const OBJECT_SCALE_MAP: Record<string, number> = {
  "1": 1.0,
  "2": 1.0,
  "3": 1.0,
  "4": 1.0,
  "5": 1.0,
  "6": 1.0,
  "7": 1.0,
  "8": 1.0,
  "9": 2.0,
  "10": 2.0,
  "11": 2.0,
  "12": 1.0,
  "13": 1.0,
  "14": 2.0,
  "15": 1.0,
  "16": 2.0,
  "17": 1.0,
  "18": 1.0,
};

const clampMin = (value: number, min: number) => Math.max(min, Math.round(value));

export const getSceneObjectDimensions = (
  objectId: string,
  isMobile: boolean
): SceneObjectDimensions => {
  const baseSize = isMobile ? BASE_OBJECT_SIZE_MOBILE : BASE_OBJECT_SIZE_DESKTOP;
  const scale = OBJECT_SCALE_MAP[objectId] ?? 1.0;
  const size = clampMin(baseSize * scale, 24);

  return {
    width: size,
    height: size,
  };
};
